
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { UseFormReturn } from 'react-hook-form';
import { FormValues } from './types';

interface CommentsFieldProps {
  form: UseFormReturn<FormValues>;
}

export const CommentsField: React.FC<CommentsFieldProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="additionalComments"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Additional Comments (optional)</FormLabel>
          <FormControl>
            <Textarea
              placeholder="Any additional information you'd like to share"
              className="min-h-[80px]"
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
